module.exports = __webpack_public_path__ + "static/media/04.1d0684bb.png";